/**
 * Auto-generated from openapi/admin-v1.openapi.json.
 * Do not edit manually.
 */

export const operationPolicies = {
  "archiveExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/archive",
    "roles": [
      "fitness-admin"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "archiveProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/archive",
    "roles": [
      "fitness-admin"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "cloneExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/clone",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "cloneProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/clone",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "completeMediaUpload": {
    "method": "POST",
    "path": "/admin/v1/media/{asset_id}/complete",
    "roles": [
      "fitness-admin",
      "fitness-media-manager"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "createExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "createMediaUpload": {
    "method": "POST",
    "path": "/admin/v1/media/uploads",
    "roles": [
      "fitness-admin",
      "fitness-media-manager"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "createProgram": {
    "method": "POST",
    "path": "/admin/v1/programs",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": false
  },
  "deleteMediaAsset": {
    "method": "DELETE",
    "path": "/admin/v1/media/{asset_id}",
    "roles": [
      "fitness-admin",
      "fitness-media-manager"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "getAdminCapabilities": {
    "method": "GET",
    "path": "/admin/v1/capabilities",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "getAdminSession": {
    "method": "GET",
    "path": "/admin/v1/session",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "getExercise": {
    "method": "GET",
    "path": "/admin/v1/exercises/{exercise_id}",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "getMediaAsset": {
    "method": "GET",
    "path": "/admin/v1/media/{asset_id}",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "getMediaPolicy": {
    "method": "GET",
    "path": "/admin/v1/media/policy",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "getProgram": {
    "method": "GET",
    "path": "/admin/v1/programs/{program_id}",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listDifficulties": {
    "method": "GET",
    "path": "/admin/v1/taxonomies/difficulties",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listEquipment": {
    "method": "GET",
    "path": "/admin/v1/taxonomies/equipment",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listExercises": {
    "method": "GET",
    "path": "/admin/v1/exercises",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listExerciseTypes": {
    "method": "GET",
    "path": "/admin/v1/taxonomies/exercise-types",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listMedia": {
    "method": "GET",
    "path": "/admin/v1/media",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listMuscles": {
    "method": "GET",
    "path": "/admin/v1/taxonomies/muscles",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "listPrograms": {
    "method": "GET",
    "path": "/admin/v1/programs",
    "roles": [
      "fitness-admin",
      "fitness-admin-viewer",
      "fitness-content-editor",
      "fitness-content-publisher",
      "fitness-media-manager"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "publishExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/publish",
    "roles": [
      "fitness-admin",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "publishProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/publish",
    "roles": [
      "fitness-admin",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "restoreExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/restore",
    "roles": [
      "fitness-admin"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "restoreProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/restore",
    "roles": [
      "fitness-admin"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "unpublishExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/unpublish",
    "roles": [
      "fitness-admin",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "unpublishProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/unpublish",
    "roles": [
      "fitness-admin",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": true,
    "ifMatchRequired": true
  },
  "updateExercise": {
    "method": "PATCH",
    "path": "/admin/v1/exercises/{exercise_id}",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": true
  },
  "updateProgram": {
    "method": "PATCH",
    "path": "/admin/v1/programs/{program_id}",
    "roles": [
      "fitness-admin",
      "fitness-content-editor"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": true
  },
  "validateExercise": {
    "method": "POST",
    "path": "/admin/v1/exercises/{exercise_id}/validate",
    "roles": [
      "fitness-admin",
      "fitness-content-editor",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  },
  "validateProgram": {
    "method": "POST",
    "path": "/admin/v1/programs/{program_id}/validate",
    "roles": [
      "fitness-admin",
      "fitness-content-editor",
      "fitness-content-publisher"
    ],
    "idempotencyRequired": false,
    "ifMatchRequired": false
  }
} as const

export type AdminOperationId = keyof typeof operationPolicies
export type AdminRole = (typeof operationPolicies)[AdminOperationId]['roles'][number]
